import { gql } from '@apollo/client';

const GET_USER_INFO = gql`
  query getUserInfo {
    currentUser {
      Email
      SystemRole {
        DisplayName
      }
    }
    getUserMddapOrganizationName
    getUserMddapOrganizationUnitNames
  }
`;

export default GET_USER_INFO;
